export { Paper } from "@mantine/core";
export type { PaperProps } from "@mantine/core";
export { paperOverrides } from "./Paper.config";
